import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ResponseResult } from '@app/auth/model';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  private route: string = "admin";
  private controller: string = "calendar";
  private endpointPrefix: string;

  constructor(private http: HttpClient) {
    this.endpointPrefix = `${environment.urlAPI}/${this.route}/${this.controller}`;
  }

  getTeacherCalendarById(teacherId: any): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/TeacherCalendar/${teacherId}`);
  }

  getStudentCalendarById(studentId: any): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/StudentCalendar/${studentId}`);
  }

  getStudentCourseCalendarByIdentifier(identifier: any): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/StudentCourseCalendar/${identifier}`);
  }
}
